// extracted by mini-css-extract-plugin
export var closeButton = "FullScreenSearchDialog-module--closeButton--74f9b";
export var dialog = "FullScreenSearchDialog-module--dialog--d7c6d";
export var searchInputOffset = "FullScreenSearchDialog-module--searchInputOffset--846ce";
export var searchModal = "FullScreenSearchDialog-module--searchModal--a5194";